module.exports = __webpack_public_path__ + "static/media/hamburger_menu.23a8ff06.svg";